import { useSelector } from "react-redux";
import { campaignSelector } from "../../store/store";
import CampaignMenu from "./CampaignMenu";
import CampaignName from "./CampaignName";
import AddProspects from "./AddProspects";
import AddActions from "./AddActions";
import { useEffect, useState } from "react";
import ReviewCampaign from "./ReviewCampaign";

type Props = {
  setShowExpiredAlert: any;
};

const CreateSteps = (props: Props) => {
  const { currentStep } = useSelector(campaignSelector);

  return (
    <section className="flex h-full min-h-0 w-full flex-col gap-4 overflow-hidden rounded-md bg-white p-3 text-sm lg:flex-row lg:p-4">
      <CampaignMenu />
      <div className="flex min-h-0 min-w-0 w-full flex-1 items-center justify-center overflow-auto rounded-md bg-slate-100">
        {currentStep.idx === 0 && <CampaignName />}
        {currentStep.idx === 1 && <AddProspects />}
        {currentStep.idx === 2 && <AddActions />}
        {currentStep.idx === 3 && (
          <ReviewCampaign setShowExpiredAlert={props.setShowExpiredAlert} />
        )}
      </div>
    </section>
  );
};

export default CreateSteps;
